import Vue from 'vue';
import ElementUI from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
// import 'element-ui/lib/theme-chalk/index.css';
import 'element-theme-dark';

locale.use(lang);
Vue.use(ElementUI, {
    size: 'small'
});